import script from "./ProfilePhoto.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePhoto.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePhoto.vue?vue&type=style&index=0&id=6c55fb75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c55fb75"]])

export default __exports__